export default __webpack_public_path__ + "static/media/Audio-Number-7.f39c7eef.mp3";